import * as base64 from "base64-js";

import { StoredBuilder } from "./storedFormat/index.ts";
import { KeywordParser } from "./storedFormat/textFormat.ts";

/**
 * Turn a human readable keyword match expression into a compiled base64 string
 * @param keywords
 */
export const compileExpression = (keywords: string) => {
  const output = new StoredBuilder();
  const parser = new KeywordParser(keywords, output);
  parser.parseCore();
  if (parser.getErrorString() !== "") {
    throw new Error(`Invalid keyword expression: ${parser.getErrorString()}`);
  }
  return base64.fromByteArray(output.getResult());
};
